export const BRAND = {
  name: "Skedaddle Junk Removal",
  short: "Skedaddle",
  domain: "skedaddlejunk.com",
  phoneDisplay: "843-518-0021",
  email: "ops@skedaddlejunk.com",
  emailHref: "mailto:ops@skedaddlejunk.com",
  phoneHref: "tel:+18435180021",
  smsHref: "sms:+18435180021",
  smsPhotoHref: `sms:+18435180021?&body=${encodeURIComponent("Hi Skedaddle! Here are some photos of the junk I need gone:")}`,
  hours: "Open Mon to Sat, 8am to 6pm",
  reviewFbUrl: "https://www.facebook.com/share/1BTPXFAub5/?mibextid=wwXIfr",
  reviewGoogleUrl: "https://g.page/r/CY0L7NvdkapyEAE/review",
  heroLine: "One call and it skedaddles.",
  tagline: "Gone in a skedaddle.",
  counties: ["Charleston County", "Berkeley County", "Dorchester County"],
};

export const SLOGANS = [
  "Gone in a skedaddle.",
  "Poof. Gone. Skedaddled.",
  "Haul yeah, your junk skedaddled.",
  "Blink and it's skedaddled.",
  "One text and it skedaddles.",
  "Skedaddle on speed dial.",
];

export const MASCOT = "/mascot.png";

export const CTA = {
  quote: "Get My Free Quote",
  text: "Text us",
  textPhotos: "Text us some photos",
  call: "Call us",
};
